import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ProductUnregulatedService } from '../../../product-unregulated.service';
import {
  ICustomizedFormatUpdate,
  IHierarchyFormatUpdate,
  IProductUnregulated,
  PRODUCTS_UNREGULATED_TTL_ES
} from '../../../product-unregulated.interface';
import { UpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.template';
import { IUpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.interface';
import {
  getBasicFormatsNames,
  getCustomizedFormatNames
} from '../../../utils/formats-handler.utils';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'pg-product-unregulated-update',
  templateUrl: './product-unregulated-update.component.html',
  providers: [MessageService]
})
export class ProductUnregulatedUpdateComponent
  extends UpdateTemplate
  implements IUpdateTemplate
{
  hasPurchaseFormat = false;
  hasMinSaleFormat = false;
  disabled: boolean;
  readyToUpdate = false;
  changeForm = false;
  clonedHierarchyFormat: { [s: string]: IHierarchyFormatUpdate } = {};
  clonedCustomizedFormat: { [s: string]: ICustomizedFormatUpdate } = {};
  hierarchyFormats = [];
  statuses = [];
  nameList = [];
  hierarchyFormatLength = 0;
  customizedFormatLength = 0;
  details: any;
  saleFormatID: any;
  saleFormat: any;
  formatObj = {};
  length0fObject: number;
  subformatQuantity: number;
  i: number;
  auxHierarchy: any[];
  auxCustomized: any[];
  activeEdit: boolean;
  enabledReload: boolean;
  constructor(
    private fb: FormBuilder,
    private baseService: ProductUnregulatedService,
    private messageService: MessageService
  ) {
    super(PRODUCTS_UNREGULATED_TTL_ES, baseService);
  }

  ngOnInit() {
    const item = this.row as IProductUnregulated;
    this.enabledReload = true;
    this.activeEdit = false;
    this.fg = this.fb.group({
      code: [item.code, [Validators.required, Validators.min(1)]],
      name: [
        item.name,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      barCode: [
        item.barCode,
        [Validators.minLength(5), Validators.maxLength(32)]
      ]
    });

    this.details = item;
    this.saleFormat = item.format;
    this.length0fObject = 0;
    this.subformatQuantity = 0;
    for (const key in item.format) {
      if (item.format[key]?.subFormat) {
        this.subformatQuantity++;
      }
      this.length0fObject++;
    }

    if (this.length0fObject == 1) {
      this.disabled = false;
    }
    if (this.length0fObject - 1 != this.subformatQuantity) {
      this.hierarchyFormats = [
        {
          id: 1,
          nombre: '',
          subFormat: '',
          quantitySubFormat: 1,
          isFormatSale: false,
          isFormatSaleMin: false,
          isFormatPurchase: false
        }
      ];
    } else {
      const basicFormatNames: string[] = getBasicFormatsNames(item.format);

      const customizedFormatNames: string[] = getCustomizedFormatNames(
        item.format,
        basicFormatNames
      );
      this.i = 1;
      for (const formatName of basicFormatNames) {
        const detailsElement = this.saleFormat[formatName];

        if (
          Object.prototype.hasOwnProperty.call(
            detailsElement,
            'isFormatSaleMin'
          ) &&
          detailsElement['isFormatSaleMin'] === true
        ) {
          this.hasMinSaleFormat = true;
        }

        if (
          Object.prototype.hasOwnProperty.call(
            detailsElement,
            'isFormatPurchase'
          ) &&
          detailsElement['isFormatPurchase'] === true
        ) {
          this.hasPurchaseFormat = true;
        }

        detailsElement['nombre'] = formatName;
        detailsElement['id'] = this.i++;
        this.hierarchyFormats.push(detailsElement);
      }

      for (const formatName of customizedFormatNames) {
        const detailsCustomElement = this.saleFormat[formatName];
        detailsCustomElement['nombre'] = formatName;
      }
      this.auxHierarchy = this.hierarchyFormats;
      if (this.hierarchyFormats.length == 0) {
        this.hierarchyFormats = [
          {
            id: 1,
            nombre: '',
            subFormat: '',
            quantitySubFormat: 1,
            isFormatSale: false,
            isFormatSaleMin: false,
            isFormatPurchase: false
          }
        ];
      }
      this.hierarchyFormatLength = this.hierarchyFormats.length - 1;
    }
  }

  parseData() {
    const { code, name, barCode } = this.fg.value;
    const data = {
      code,
      name
    };
    if (barCode && barCode !== '') {
      data['barCode'] = barCode;
    }
    return data;
  }

  onHierarchyRowEdit(product: IHierarchyFormatUpdate) {
    this.clonedHierarchyFormat[product.id] = { ...product };
  }

  onHierarchyRowEditSave(product: IHierarchyFormatUpdate) {
    if (this.hierarchyFormats[product.id]) {
      this.hierarchyFormats[product.id].nombre = product.subFormat;
    }
    delete this.clonedHierarchyFormat[product.id];
    this.checkEssentialFormatsExistence();
  }

  onHierarchyRowEditCancel(product: IHierarchyFormatUpdate, index: number) {
    this.hierarchyFormats[index] = this.clonedHierarchyFormat[product.id];
    delete this.clonedHierarchyFormat[product.id];
  }

  hierarchyAddRow(ri: number) {
    this.disabled = true;
    this.hierarchyFormats.push({
      id: ri + 2,
      nombre: this.hierarchyFormats[ri].subFormat,
      subFormat: '',
      quantitySubFormat: 1,
      isFormatSale: false,
      isFormatSaleMin: false,
      isFormatPurchase: false
    });
    this.hierarchyFormatLength = this.hierarchyFormats.length - 1;
    this.checkEssentialFormatsExistence();
  }
  hierarchyDeleteRow() {
    if (this.hierarchyFormats[this.hierarchyFormatLength - 1].id == 1) {
      this.disabled = false;
    } else {
      this.disabled = true;
    }
    this.hierarchyFormats.pop();
    this.hierarchyFormatLength = this.hierarchyFormats.length - 1;
    this.checkEssentialFormatsExistence();
  }

  cambiarCheck(ri) {
    for (let index = 0; index < this.hierarchyFormats.length; index++) {
      if (index !== ri) {
        this.hierarchyFormats[index].isFormatSaleMin = false;
      }
    }
    this.hierarchyFormats[ri].subFormat = null;
  }
  setNameList() {
    this.statuses = [];
    for (let index = 0; index < this.hierarchyFormats.length; index++) {
      this.statuses.push({
        label: this.hierarchyFormats[index].nombre,
        value: this.hierarchyFormats[index].nombre
      });
    }
    this.statuses.push({ label: 'Vacío', value: '' });
  }

  output() {
    const myObj = {};
    for (const key in this.hierarchyFormats) {
      const element = this.hierarchyFormats[key];
      if (
        element.nombre !== '' &&
        element.subFormat !== '' &&
        element.quantitySubFormat !== 0
      ) {
        myObj[element.nombre] = {
          subFormat: element.subFormat === null ? undefined : element.subFormat,
          quantitySubFormat: element.quantitySubFormat,
          isFormatSale: element.isFormatSale,
          isFormatSaleMin: element.isFormatSaleMin,
          isFormatPurchase: element.isFormatPurchase
        };
      }
    }
    this.formatObj = myObj;
    this.length0fObject = 0;
    for (const key in this.formatObj) {
      this.length0fObject++;
    }
    return true;
  }
  setReadyToUpdate() {
    this.readyToUpdate =
      this.fg.value.code &&
      this.fg.value.name &&
      this.hierarchyFormats[0].nombre !== '' &&
      this.hierarchyFormats[0].subFormat !== '';
  }

  checkEssentialFormatsExistence() {
    this.hasPurchaseFormat = false;
    this.hasMinSaleFormat = false;

    for (const format of this.hierarchyFormats) {
      if (
        Object.prototype.hasOwnProperty.call(format, 'isFormatSaleMin') &&
        format['isFormatSaleMin'] === true
      ) {
        this.hasMinSaleFormat = true;
      }

      if (
        Object.prototype.hasOwnProperty.call(format, 'isFormatPurchase') &&
        format['isFormatPurchase'] === true
      ) {
        this.hasPurchaseFormat = true;
      }
    }
  }

  onSubmit() {
    this.setReadyToUpdate();
    if (this.output()) {
      if (this.readyToUpdate) {
        const generatedProduct = this.parseData();
        this.updateItem$(generatedProduct);
      }
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Campos Incompletos',
        detail: 'El Formato de Venta está incompleto'
      });
    }
  }

  clean() {
    this.enabledReload = false;
    this.activeEdit = true;
    delete this.hierarchyFormats;
    this.disabled = false;
    this.hierarchyFormatLength = 0;
    this.auxCustomized;
    this.hierarchyFormats = [
      {
        id: 1,
        nombre: '',
        subFormat: '',
        quantitySubFormat: 1,
        isFormatSale: false,
        isFormatSaleMin: false,
        isFormatPurchase: true
      }
    ];
  }
  reload() {
    this.enabledReload = false;
    this.activeEdit = true;
  }
  ngOnDestroy() {
    if (this.activeEdit) {
      location.reload();
    }
  }
}
